export default "__VITE_ASSET__5adafa47__"